<script lang="ts">
  export let size = 'normal';
  export let type = 'h1';
  export let css = '';
</script>

{#if type == 'h1'}
  <h1 class="heading h1 {size}" style=" {css};">
    <slot />
  </h1>
{:else if type == 'h2'}
  <h2 class="heading h2 {size}" style="{css};">
    <slot />
  </h2>
{:else if type == 'h3'}
  <h3 class="heading h3{size}" style="{css};">
    <slot />
  </h3>
{:else if type == 'h5'}
  <h5 class="heading h5 {size}" style="{css};">
    <slot />
  </h5>
{/if}

<style>
  .heading {
    color: var(--vlt-lp-text, #0e0f11);
    font-family: var(--vlt-lp-heading-font);
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    max-width: 100%;
    word-break: break-word;
  }
  h1.normal {
    font-weight: 700;
    font-size: 40px;
    line-height: 50px;
  }
  h2.normal {
    font-size: 40px;
    line-height: 1.2em;
  }
  h3.normal {
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: unset;
  }
  h5.normal {
    font-weight: 800;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: unset;
  }
  @media screen and (max-width: 767px) {
    h1.normal {
      font-size: 30px;
      line-height: 40px;
      letter-spacing: -0.01em;
    }
    h2.normal {
      font-size: 30px;
      letter-spacing: -0.01em;
    }
  }
</style>
